var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeeper4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1440px",
    height: "272px",
    viewBox: "0 0 1440 272",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy",
    transform: "translate(0.000000, -2455.000000)",
    fill: "#1B1B1B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "innovative..",
    transform: "translate(0.000000, 772.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1718.71875 C59.97861,1744.02738 108.97861,1758.08534 147,1760.89264 C204.032085,1765.10359 206.706181,1746.60102 278.770264,1739.80569 C350.834346,1733.01037 317.58562,1751.59836 446.5,1732.65112 C575.41438,1713.70389 554.596916,1681.7422 668.029663,1683.59747 C781.46241,1685.45275 766.313112,1739.80569 883.935425,1739.80569 C1001.55774,1739.80569 1021.37943,1683.59747 1128.03699,1683.59747 C1234.69455,1683.59747 1278.72441,1727.92366 1326.64697,1739.80569 C1358.59535,1747.72705 1396.30752,1754.75603 1439.78349,1760.89264 L1440,1954.48865 L0,1954.48865 L0,1718.71875 Z",
    id: "Path-2",
    transform: "translate(720.000000, 1819.004393) scale(-1, 1) translate(-720.000000, -1819.004393) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeeper4);
export default __webpack_public_path__ + "static/media/deeper4.a2ef7491f0cb260363e7bf5d6c5e0d9c.svg";
export { ForwardRef as ReactComponent };